export default {
  /**
   * 应用程序设定
   *
   */
  application: {
    title: '九州通幂健康开放平台-一站式大健康互联网医疗健康服务云平台'
  },

  /**
   * 主题设定
   * 可选： #00C6AE / #3099A6 / #44CC77
   *
   * 影响 Quasar & Element-UI 主题
   * Quasar 主题原生提供修改，在 boot_quasar.js 可查看
   * Element-UI 暂不支持动态修改主题色，在 boot_ui.js 可查看
   */
  theme: {
    primary: '#44CC77'
  },

  /**
   * 布局设定
   *
   */
  layout: {
    // 布局类型
    // side: 侧边栏导航布局
    type: 'side',

    // type: 'side' 时生效
    side: {
      // 是否联动顶部导航
      // true: 顶部与侧边联动导航
      // false: 纯侧边栏布局
      showTopNav: false
    }
  },
  /**
   * 默认防抖时间
   */
  debounceTime: 1500,
  /**
   * 默认截流时间
   */
  throttleTime: 1500
}
